<template>
  <div>
    <TopBar :page="topBarData"/>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card class="align-stretch" height="100%">
            <v-card-title>Quick Links</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="8">
                  <v-row class="mt-n4">
                    <template v-for="(cat,catI) in quickLinks">
                      <v-col cols="12" md="6" :key="catI" class="mb-5">
                        {{cat.name}} <br>
                        <template v-for="(link,linkI) in cat.links">
                          <span :key="linkI">
                            <a :href="link.url" :target="link.target">{{link.name}}</a> <br>
                          </span>
                        </template>
                      </v-col>
                    </template>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4">
                  bHive Icon <br>
                  <BeehiveIcon /> <br>
                  Keep an eye out for the bHive icon! Anywhere you see the bHive icon, you can click it to get more information about how to use a feature in the CRM.
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="align-stretch" height="100%">
            <v-card-title>Recently Viewed</v-card-title>
            <v-card-text>
              <v-list-item-group>

                <template v-for="(recent, recentI) in getRecentlyViewedItems">
                  <v-list-item :key="recentI" @click="navToPage(recent)">
                    <template v-if="recent.type==='accounts'">
                      <v-list-item-avatar color="primary"><v-icon color="white" :style="icons.size">{{ icons.accounts }}</v-icon></v-list-item-avatar>
                    </template>
                    <template v-if="recent.type==='retention-leads'">
                      <v-list-item-avatar color="tertiary"><v-icon color="white" :style="icons.size">{{ icons.retentionLeads }}</v-icon></v-list-item-avatar>
                    </template>
                    <template v-if="recent.type==='voip'">
                      <v-list-item-avatar color="secondary"><v-icon color="white" :style="icons.size">{{ icons[recent.type] }}</v-icon></v-list-item-avatar>
                    </template>
                    <template v-if="recent.type==='telco'">
                      <v-list-item-avatar color="secondary darken-1"><v-icon color="white" :style="icons.size">{{ icons[recent.type] }}</v-icon></v-list-item-avatar>
                    </template>
                    <template v-if="recent.type==='web'">
                      <v-list-item-avatar color="secondary darken-2"><v-icon color="white" :style="icons.size">{{ icons[recent.type] }}</v-icon></v-list-item-avatar>
                    </template>
                    <v-list-item-content>
                      <v-list-item-title><b>{{recent.id}}</b> - {{recent.name}}</v-list-item-title>
                      <v-list-item-subtitle>Last viewed - {{formatDate(recent.datetime)}}</v-list-item-subtitle>
                    </v-list-item-content>
                    <template v-if="['voip','telco','web'].indexOf(recent.type)!==-1">
                      <v-list-item-action class="my-0">
                        <div class="d-flex justify-start">
                          <div>{{recent.status}}</div>
                          <div class="ml-4 mt-n5"><LeadLink :leadid="recent.id" /></div>
                        </div>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>

              </v-list-item-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <TicketsListTable :onPage="'dashboard'" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import LeadLink from '@/components/Globals/LeadLink';
  import TicketsListTable from "@/components/Tickets/TicketsListTable";
  import { mdiAccountBoxMultiple,mdiGavel,mdiFinance,mdiAccount,mdiHeadset,mdiRouterWireless,mdiMonitorDashboard } from '@mdi/js';
  import TopBar from "./../../components/Layout/TopBar";
  import BeehiveIcon from '@/components/Globals/BeehiveIcon';

  import { mapState,mapActions,mapGetters } from "vuex";
  import moment from 'moment';
  import { links  } from '@/helpers/links';

  const availabilityCheckerUrl = process.env.VUE_APP_MY_BONLINE_DOMAIN ? `${process.env.VUE_APP_MY_BONLINE_DOMAIN}broadband-availability` : links.availabilityCheckerTesting;

  export default {
    components: { TopBar,TicketsListTable,LeadLink,BeehiveIcon },
    computed: {
      ...mapState('globals', ['recentlyViewed']),
      ...mapGetters('globals', ['getRecentlyViewedItems']),
    },
    async mounted () {
      this.getRecentlyViewed();
    },
    data() {
      return {
        icons: {
          size: 'font-size:24px;width:24px;height:24px;',
          accounts: mdiAccount,
          voip: mdiHeadset,
          telco: mdiRouterWireless,
          web: mdiMonitorDashboard,
          retentionLeads: mdiGavel,
        },
        topBarData: {
          name: 'Dashboard',
          type: 'dashboard',
          showSearch: true,
          menu: false,
          breadcrumbs: [],
          showBeehiveIcon: true,
          articleLink: 'dashboard',
        },
        quickLinks: [
          {
            name: 'bOnline',
            links: [
              { name: 'bHive', target: '_blank', url: 'https://sites.google.com/bonline.com/bhive/home' },
              { name: 'Customer Knowledgebase', target: '_blank', url: 'https://help.bonline.com/' },
              { name: 'Service FAQs', target: '_blank', url: 'https://sites.google.com/bonline.com/service-faqs/home' },
              { name: 'Chrome Extension', target: '_blank', url: 'https://chrome.google.com/webstore/detail/bonline-chrome-extension/fglnjoablnalgbemmipldieigmfecjcp?hl=en-GB&authuser=0' },
              { name: 'Availability Checker', target: '_blank', url: availabilityCheckerUrl }
            ]
          },
          {
            name: 'External',
            links: [
              { name: 'TTB Portal', target: '_blank', url: 'https://ttbportal.mytalktalkbusiness.co.uk/' },
              { name: 'Gamma Portal', target: '_blank', url: 'https://www.gamma-portal.com/' },
              { name: 'ConnexOne', target: '_blank', url: 'https://bonline-cxm.cnx1.cloud/' },
              { name: 'MyTelephony', target: '_blank', url: 'https://admin.phone.bonline.com/login/#/' },
              { name: 'WebAdmin', target: '_blank', url: 'https://webadmin.phone.bonline.com/pages/common/login.jsp' },
              { name: 'Net Lynk', target: '_blank', url: 'https://www.bbtrack.com/bonlinehdm/agent_login.asp' },
              { name: 'Onboarding Calendar', target: '_blank', url: 'https://calendly.com/bonline-onboarding' },
              { name: 'Broadcloud', target: '_blank', url: 'https://voip.bonline.com/control/main' },
            ]
          },
          {
            name: 'Telco',
            links: [
              { name: 'SI', target: '_blank', url: 'https://bonline.imperatives.co.uk/' },
              { name: 'Talk Talk Portal', target: '_blank', url: 'https://ttbportal.mytalktalkbusiness.co.uk' },
              { name: 'BT Portal', target: '_blank', url: 'https://www.btbroadbandcomplete.com' },
            ]
          },
          {
            name: 'Sales',
            links: [
              { name: 'Vicidial', target: '_blank', url: 'https://ds014.hostcommservers.co.uk/agc/vicidial.php' },
              { name: 'Vicidial Reports', target: '_blank', url: 'https://ds014.hostcommservers.co.uk/vicidial/realtime_report.php#' },
            ]
          },
        ],
        quickNav: [
          { name: 'Billing Accounts', icon: mdiAccountBoxMultiple, url: 'accounts' },
          { name: 'Retention Leads', icon: mdiGavel, url: 'retention' },
          { name: 'Retention Reports', icon: mdiFinance, url: 'retentionreports' },
        ]
      }
    },
    methods: {
      ...mapActions('globals', ['getRecentlyViewed']),
      goToNav(url) {
        this.$router.push({name:url});
      },
      navToPage(recent) {
        let url;
        if(recent.type==='accounts'){
          url = `/accounts/${recent.id}/`;
        }else if(recent.type==='retention-leads'){
          url = `/retention/${recent.id}/`;
        }else{
          url = `/products/${recent.id}/`;
        }
        
        this.$router.push(url);
      },
      formatDate(date){
        return moment(date).format('YYYY-MM-DD HH:mm');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
